module.exports = __webpack_public_path__ + "6f40b1f4cb9ab59fd9b1d65c209cdcd2.fbx";